import { gql } from '@apollo/client';

export default class EmployeeMutation {
    static UPDATE_EMPLOYEE_LOGIN_PERMISSION = gql`
        mutation updateEmployeeLoginPermission(
            $userId: Int!
            $input: EmployeeLoginPermissionInput!
            $origin: String
        ) {
            updateEmployeeLoginPermission(userId: $userId, input: $input, origin: $origin)
        }
    `;

    static SEND_EMPLOYEE_PASSWORD_RESET = gql`
        mutation sendEmployeePasswordReset($userId: Int!, $origin: String!) {
            sendEmployeePasswordReset(userId: $userId, origin: $origin)
        }
    `;
}
